import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { fontSize } from "style";
import { WhiteLink } from "components/Links";
import { useAuth, useLinks } from "hooks";

/**
 * FAQ Menu Item
 */
const MenuItemFaq = (props) => {
  const { isAdmin } = useAuth();
  const links = useLinks();

  if (isAdmin) return null;

  return (
    <FAQ {...props}>
      <span>
        <FormattedMessage
          id="Nav.SideNav.LabelNeedHelp"
          values={{
            faq: (
              <>
                <WhiteLink href={links.faq} target="_blank">
                  <span css={styles.bold}>
                    <FormattedMessage id="Nav.SideNav.LabelFAQ" />
                  </span>
                </WhiteLink>
              </>
            ),
          }}
        />
      </span>
    </FAQ>
  );
};

const FAQ = styled.div`
  font-weight: 400;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 0.6rem;
  font-size: ${fontSize.xsmall};
`;

const styles = {
  bold: css`
    font-weight: 700;
  `,
};

export default MenuItemFaq;
